export type ProductSource = 
  | 'manual'
  | 'api'
  | 'ai'
  | 'gemini'
  | 'openfoodfacts'
  | 'ean-db'
  | 'fallback-local'
  | 'nan';

export const OFFICIAL_PRODUCT_SOURCES: ProductSource[] = [
  'manual',
  'api',
  'ai',
  'gemini',
  'openfoodfacts',
  'ean-db',
  'fallback-local',
  'nan'
];

/**
 * Normaliza a string da fonte de dados para um dos valores oficiais aceitos na CHECK CONSTRAINT de produtos_barcode:
 * 'manual' | 'api' | 'ai' | 'gemini' | 'openfoodfacts' | 'ean-db' | 'fallback-local' | 'nan'
 */
export function normalizeProductSource(source?: string | null): ProductSource {
  if (source === null || source === undefined) {
    return 'nan';
  }

  const s = String(source).trim().toLowerCase();
  if (!s || s === 'nan' || s === 'null' || s === 'undefined' || s === '-') {
    return 'nan';
  }

  // Exact matches
  if (s === 'manual') return 'manual';
  if (s === 'api') return 'api';
  if (s === 'ai' || s === 'ia') return 'ai';
  if (s === 'gemini') return 'gemini';
  if (s === 'openfoodfacts' || s === 'off') return 'openfoodfacts';
  if (s === 'ean-db' || s === 'eandb' || s === 'ean_db' || s === 'ean') return 'ean-db';
  if (s === 'fallback-local' || s === 'local') return 'fallback-local';

  // Pattern / partial matches
  if (s.includes('openfoodfacts') || s.includes('off')) {
    return 'openfoodfacts';
  }
  if (s.includes('gemini')) {
    return 'gemini';
  }
  if (s.includes('ean')) {
    return 'ean-db';
  }
  if (s.includes('manual') || s.includes('fusão mdm') || s.includes('fusao mdm') || s.includes('pim') || s.includes('dqc') || s.includes('data quality center')) {
    return 'manual';
  }
  if (s.includes('heurística') || s.includes('heuristica') || s.includes('local') || s.includes('cache') || s.includes('csv') || s.includes('json') || s.includes('importa') || s.includes('fallback')) {
    return 'fallback-local';
  }
  if (s.includes('api')) {
    return 'api';
  }
  if (s.includes('ai') || s.includes('ia') || s.includes('inteligência') || s.includes('inteligencia')) {
    return 'ai';
  }

  return 'fallback-local';
}

/**
 * Retorna um rótulo amigável para exibição em interfaces de usuário
 */
export function formatProductSourceLabel(source?: string | null): string {
  const norm = normalizeProductSource(source);
  switch (norm) {
    case 'manual':
      return 'Manual';
    case 'api':
      return 'API';
    case 'ai':
      return 'IA';
    case 'gemini':
      return 'Gemini IA';
    case 'openfoodfacts':
      return 'OpenFoodFacts';
    case 'ean-db':
      return 'EAN-DB';
    case 'fallback-local':
      return 'Heurística Local';
    case 'nan':
    default:
      return 'Não informado';
  }
}
